module.exports = new __parcel__URL__("FFF_Logo.a25cb118.png").toString();